import React from 'react'
import ReactDOM from 'react-dom/client'
import { startDeployVersionGuard } from '@huay/shared/deployVersionGuard'
import App from './App'
import './index.css'

startDeployVersionGuard({ appName: 'user-classic' })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
